import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Select from '../../../../../../components/CustomSelect/Select';
import ReactTooltip from "react-tooltip";
import PhoneInput from "react-phone-input-2";
import countryList from "react-select-country-list";

import { Field } from "formik";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import moment from "moment";

import { findCountry } from "../../../../../../common/functions/utils";
import CustomDate from "../../../../../../components/CustomDate";
import styles from "./addnewbooking.module.css";


const ContactForm = (props) => {

    const {
        contactType,
        setFieldValue,
        handleChange,
        validateForm,
    } = props;

    const values = props.values[`${contactType}`];
    const errors = props.errors[`${contactType}`];

    const isFirstRender = useRef(true);
    const user = useSelector(({ generalSetting }) => generalSetting && generalSetting.setting);
    const guestList = useSelector(({ guests }) => guests && guests.guestList);

    const [userCode] = useState(findCountry(values?.country || user.country));
    const [phoneNumber, setPhoneNumber] = useState(userCode);
    const [secondaryPhoneNumber, setSecondaryPhoneNumber] = useState(userCode);
    const [showMoreContactDetails, setShowMoreContactDetails] = useState(false);

    const compare = (a, b) => {
        return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
    };

    useEffect(() => {
        // Prevents the first render from running the validation
        if (isFirstRender.current <= 4) {
            isFirstRender.current++;
            return;
        };

        // Run only after the first render
        validateForm();

    }, [props.values]);

    useEffect(() => {

        if (values.id) {
            const contact = guestList.find((guest) => guest.id === values.id);

            setFieldValue(`${contactType}.name`, contact.name);
            setFieldValue(`${contactType}.emailId`, contact.emailId);
            setFieldValue(`${contactType}.secondaryEmailId`, contact.secondaryEmailId);
            setFieldValue(`${contactType}.phoneNo`, contact.phoneNo);
            setFieldValue(`${contactType}.secondaryPhoneNo`, contact.secondaryPhoneNo);
            setFieldValue(`${contactType}.postalCode`, contact.postalCode);
            setFieldValue(`${contactType}.country`, contact.country);
            setFieldValue(`${contactType}.address`, contact.address);
            setFieldValue(`${contactType}.street`, contact.street);
            setFieldValue(`${contactType}.state`, contact.state);
            setFieldValue(`${contactType}.nationality`, contact.nationality);
            setFieldValue(`${contactType}.language`, contact.language);
            setFieldValue(`${contactType}.company`, contact.company);
            setFieldValue(`${contactType}.companyAddress`, contact.companyAddress);
            setFieldValue(`${contactType}.moreInfo`, contact.notes);

            setPhoneNumber(contact.phoneNo || userCode);
            setSecondaryPhoneNumber(contact.secondaryPhoneNo || userCode);

            if (contact.dob && !["Invalid da", "", null, "[NULL]"].includes(contact.dob)) {
                setFieldValue(`${contactType}.dob`, new Date(moment(contact.dob)));
            } else {
                setFieldValue(`${contactType}.dob`, null);
            };

        } else {
            setFieldValue(`${contactType}.name`, "");
            setFieldValue(`${contactType}.emailId`, "");
            setFieldValue(`${contactType}.secondaryEmailId`, "");
            setFieldValue(`${contactType}.phoneNo`, "");
            setFieldValue(`${contactType}.secondaryPhoneNo`, "");
            setFieldValue(`${contactType}.postalCode`, "");
            setFieldValue(`${contactType}.country`, "");
            setFieldValue(`${contactType}.address`, "");
            setFieldValue(`${contactType}.street`, "");
            setFieldValue(`${contactType}.state`, "");
            setFieldValue(`${contactType}.nationality`, "");
            setFieldValue(`${contactType}.language`, "");
            setFieldValue(`${contactType}.company`, "");
            setFieldValue(`${contactType}.companyAddress`, "");
            setFieldValue(`${contactType}.moreInfo`, "");
            setFieldValue(`${contactType}.dob`, null);

            setPhoneNumber(userCode);
            setSecondaryPhoneNumber(userCode);
        };

    }, [values.id])

    return (
        <>
            <Row>
                <Col>
                    <div className={`${styles.searchContainer}`}>
                        <Select
                            type=""
                            name={`${contactType}.id`}
                            value={values.selectedContactData}
                            onChange={(data) => {
                                setFieldValue(`${contactType}.selectedContactData`, data);
                                setFieldValue(`${contactType}.selectedContact`, (data?.value ? true : false));
                                setFieldValue(`${contactType}.id`, (data?.value ?? ""));
                            }}
                            options={guestList.map((row) => ({ label: row.name, value: row.id })).sort(compare)}
                            isSearchable={true}
                            isClearable={true}
                            placeholder={contactType === "guest" ? 
                                "Search guest…"
                                : 
                                "Search contact…"
                            }
                            className="w-100"
                        />
                        <div className={`${styles.paragraphBelowSearch} d-flex align-items-center`}>
                            <hr className={`${styles.hrClass} flex-grow-1`} />
                            <p className="mx-3">or add {`${contactType === "guest" ? "new guest" : "booker to contacts"}`}</p>
                            <hr className={`${styles.hrClass} flex-grow-1`} />
                        </div>
                    </div>
                    <div className={`d-flex ${styles.form_wrapper}`} key="name">
                        <div className={`d-flex ${styles.form_title}`}>
                            Name*:
                        </div>
                        <div className="w-100">
                            <Field
                                type="text"
                                name={`${contactType}.name`}
                                value={values.name}
                                onChange={handleChange}
                                disabled={values.selectedContact}
                                className={errors?.name ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                            />
                            <div className={errors?.name ? styles.form_error : styles.form_error_hidden}>
                                {errors?.name}
                            </div>
                        </div>
                    </div>
                    <div className={`d-flex ${styles.form_wrapper}`} key="company">
                        <div className={`d-flex ${styles.form_title}`}>
                            Company:
                        </div>
                        <div className="w-100">
                            <Field
                                type="text"
                                name={`${contactType}.company`}
                                value={values.company}
                                onChange={handleChange}
                                disabled={values.selectedContact}
                                className={errors?.company ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                            />
                            <div className={errors?.company ? styles.form_error : styles.form_error_hidden}>
                                {errors?.company}
                            </div>
                        </div>
                    </div>
                </Col>
                <Col className={styles.secondColumnOfGuestDetails}>
                    <div className={`d-flex ${styles.form_wrapper}`} key="emailId">
                        <div className={`d-flex ${styles.form_title}`}>
                            Email:
                        </div>
                        <div className="w-100">
                            <Field
                                type="text"
                                name={`${contactType}.emailId`}
                                value={values.emailId}
                                onChange={handleChange}
                                disabled={values.selectedContact}
                                className={errors?.emailId ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                            />
                            <div className={errors?.emailId ? styles.form_error : styles.form_error_hidden}>
                                {errors?.emailId}
                            </div>
                        </div>
                    </div>
                    <div className={`d-flex ${styles.form_wrapper}`} key="phoneNo">
                        <div className={`d-flex ${styles.form_title}`}>
                            Phone:
                        </div>
                        <div className="w-100">
                            <PhoneInput
                                name={`${contactType}.phoneNo`}
                                country={userCode}
                                value={phoneNumber}
                                onChange={(value, data, event, formattedValue) => {
                                    const rawVal = value.slice(data.dialCode.length);
                                    const phone = rawVal ? `+${data.dialCode} ${rawVal}` : "";
                                    setFieldValue(`${contactType}.phoneNo`, phone);
                                    setPhoneNumber(phone || data.dialCode);
                                }}
                                inputStyle={{ width: "100%" }}
                                countryCodeEditable={false}
                                enableSearch={true}
                                disableSearchIcon={true}
                                disabled={values.selectedContact}
                            />
                            <div className={errors?.phoneNo ? styles.form_error : styles.form_error_hidden}>
                                {errors?.phoneNo}
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            {showMoreContactDetails && (
                <>
                    <hr />
                    <Row>
                        <Col>
                            <div className={`d-flex ${styles.form_wrapper}`} key="companyAddress">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Company address:
                                </div>
                                <div className="w-100">
                                    <Field
                                        type="text"
                                        name={`${contactType}.companyAddress`}
                                        value={values.companyAddress}
                                        onChange={handleChange}
                                        disabled={values.selectedContact}
                                        className={errors?.companyAddress ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                    />
                                    <div className={errors?.companyAddress ? styles.form_error : styles.form_error_hidden}>
                                        {errors?.companyAddress}
                                    </div>
                                </div>
                            </div>
                            <div className={`d-flex ${styles.form_wrapper}`} key="language">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Language:
                                </div>
                                <div className="w-100">
                                    <Field
                                        type="text"
                                        name={`${contactType}.language`}
                                        value={values.language}
                                        onChange={handleChange}
                                        disabled={values.selectedContact}
                                        className={errors?.language ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                    />
                                    <div className={errors?.language ? styles.form_error : styles.form_error_hidden}>
                                        {errors?.language}
                                    </div>
                                </div>
                            </div>
                            <div className={`d-flex ${styles.form_wrapper}`} key="country">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Country:
                                </div>
                                <div className="w-100">
                                    <Select
                                        name={`${contactType}.country`}
                                        value={values?.country ? { label: values?.country, value: values?.country } : ""}
                                        onChange={(val) => {
                                            setFieldValue(`${contactType}.country`, (val?.label ?? ""));
                                        }}
                                        options={countryList().getData()}
                                        isClearable={true}
                                        isDisabled={values.selectedContact}
                                        className={styles.form_entry_select}
                                    />
                                </div>
                            </div>
                            <div className={`d-flex ${styles.form_wrapper}`} key="nationality">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Nationality:
                                </div>
                                <div className="w-100">
                                    <Field
                                        type="text"
                                        name={`${contactType}.nationality`}
                                        value={values.nationality}
                                        onChange={handleChange}
                                        disabled={values.selectedContact}
                                        className={errors?.nationality ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                    />
                                    <div className={errors?.nationality ? styles.form_error : styles.form_error_hidden}>
                                        {errors?.nationality}
                                    </div>
                                </div>
                            </div>
                            <div className={`d-flex ${styles.form_wrapper}`} key="dob">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Birthday:
                                </div>
                                <div className="w-100">
                                    <CustomDate
                                        id="dob"
                                        name={`${contactType}.dob`}
                                        value={values.dob}
                                        handleChange={(date) => setFieldValue(`${contactType}.dob`, date, true)}
                                        disabled={values.selectedContact}
                                        customClass={errors?.dob ? styles.form_entry_err : styles.form_entry}
                                        max={new Date()}
                                        min={new Date(`${(new Date().getUTCFullYear()) - 100}-01-01`)}
                                    />
                                    <div className={errors?.dob ? styles.form_error : styles.form_error_hidden}>
                                        {errors?.dob}
                                    </div>
                                </div>
                            </div>
                            <div className={`d-flex ${styles.form_wrapper}`} key="moreInfo">
                                <div className={`d-flex ${styles.form_title}`}>
                                    More info:
                                    <InfoOutlinedIcon
                                        fontSize="small"
                                        color="inherit"
                                        data-tip
                                        data-for="moreInfo"
                                        className={styles.toolTipIcon}
                                    />
                                    <ReactTooltip place="bottom" type="dark" id="moreInfo" effect="solid" className={styles.toolTip}>
                                        <span>
                                            Write more information or notes specific to your contact here.
                                            These can be retrieved later if the contact makes another reservation.
                                        </span>
                                    </ReactTooltip>
                                </div>
                                <div className="w-100">
                                    <Field
                                        type="text"
                                        name={`${contactType}.moreInfo`}
                                        value={values.moreInfo}
                                        onChange={handleChange}
                                        disabled={values.selectedContact}
                                        className={errors?.moreInfo ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className={`d-flex ${styles.form_wrapper}`} key="secondaryEmailId">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Secondary email:
                                </div>
                                <div className="w-100">
                                    <Field
                                        type="text"
                                        name={`${contactType}.secondaryEmailId`}
                                        value={values.secondaryEmailId}
                                        onChange={handleChange}
                                        disabled={values.selectedContact}
                                        className={errors?.secondaryEmailId ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                    />
                                    <div className={errors?.secondaryEmailId ? styles.form_error : styles.form_error_hidden}>
                                        {errors?.secondaryEmailId}
                                    </div>
                                </div>
                            </div>
                            <div className={`d-flex ${styles.form_wrapper}`} key="secondaryPhoneNo">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Secondary phone:
                                </div>
                                <div className="w-100">
                                    <PhoneInput
                                        name={`${contactType}.secondaryPhoneNo`}
                                        country={userCode}
                                        value={secondaryPhoneNumber}
                                        onChange={(value, data, event, formattedValue) => {
                                            const rawVal = value.slice(data.dialCode.length);
                                            const phone = rawVal ? `+${data.dialCode} ${rawVal}` : "";
                                            setFieldValue(`${contactType}.secondaryPhoneNo`, phone);
                                            setSecondaryPhoneNumber(phone || data.dialCode);
                                        }}
                                        inputStyle={{ width: "100%" }}
                                        countryCodeEditable={false}
                                        enableSearch={true}
                                        disableSearchIcon={true}
                                        disabled={values.selectedContact}
                                    />
                                    <div className={errors?.secondaryPhoneNo ? styles.form_error : styles.form_error_hidden}>
                                        {errors?.secondaryPhoneNo}
                                    </div>
                                </div>
                            </div>
                            <div className={`d-flex ${styles.form_wrapper}`} key="street">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Street and nr:
                                </div>
                                <div className="w-100">
                                    <Field
                                        type="text"
                                        name={`${contactType}.street`}
                                        value={values.street}
                                        onChange={handleChange}
                                        disabled={values.selectedContact}
                                        className={errors?.street ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                    />
                                    <div className={errors?.street ? styles.form_error : styles.form_error_hidden}>
                                        {errors?.street}
                                    </div>
                                </div>
                            </div>
                            <div className={`d-flex ${styles.form_wrapper}`} key="postalCode">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Postal code:
                                </div>
                                <div className="w-100">
                                    <Field
                                        type="text"
                                        name={`${contactType}.postalCode`}
                                        value={values.postalCode}
                                        onChange={handleChange}
                                        disabled={values.selectedContact}
                                        className={errors?.postalCode ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                    />
                                    <div className={errors?.postalCode ? styles.form_error : styles.form_error_hidden}>
                                        {errors?.postalCode}
                                    </div>
                                </div>
                            </div>
                            <div className={`d-flex ${styles.form_wrapper}`} key="state">
                                <div className={`d-flex ${styles.form_title}`}>
                                    State/Province:
                                </div>
                                <div className="w-100">
                                    <Field
                                        type="text"
                                        name={`${contactType}.state`}
                                        value={values.state}
                                        onChange={handleChange}
                                        disabled={values.selectedContact}
                                        className={errors?.state ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                    />
                                    <div className={errors?.state ? styles.form_error : styles.form_error_hidden}>
                                        {errors?.state}
                                    </div>
                                </div>
                            </div>
                            <div className={`d-flex ${styles.form_wrapper}`} key="address">
                                <div className={`d-flex ${styles.form_title}`}>
                                    Address details:
                                </div>
                                <div className="w-100">
                                    <Field
                                        type="text"
                                        name={`${contactType}.address`}
                                        value={values.address}
                                        onChange={handleChange}
                                        disabled={values.selectedContact}
                                        className={errors?.address ? `is-invalid ${styles.form_entry_err}` : styles.form_entry}
                                    />
                                    <div className={errors?.address ? styles.form_error : styles.form_error_hidden}>
                                        {errors?.address}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </>
            )}
            <div className="d-flex justify-content-start">
                <h3 className={styles.showMoreDetails}>Show {!showMoreContactDetails ? "more" : "less"}</h3>
                {!showMoreContactDetails ?
                    <ExpandMoreIcon className={styles.btnArrowMore} onClick={() => setShowMoreContactDetails(true)} />
                    :
                    <ExpandLessIcon className={styles.btnArrowLess} onClick={() => setShowMoreContactDetails(false)} />
                }
            </div>
        </>
    )
}

export default ContactForm;